import React from "react";

import { AddressPropType } from "@models/shared/shared.model";

const Address: React.FC<AddressPropType> = ({ address, title, unitName }) => {
  return (
    <div className="fg-loc-custom-block" data-testid="address">
      <h5>{title}</h5>
      <div className="fg-find-org">
        <div>
          <span className="fg-address-unit-name">{unitName}</span>
          <br />
          <p>{address}</p>
        </div>
      </div>
    </div>
  );
};

export default Address;
